import { useTranslation } from 'react-i18next';
import { useRouteDocumentTitle } from '@client/toolkit';
import { ReportingPaths } from '../reporting.router';
import { AirQualityGraphSection } from './components/air-quality-graph';
import { ReportPageContent } from '../../../components/layout/report-page-content';
import { DashboardFiltersProvider } from '../../dashboard/context/dashboard-filters.context';
import { DashboardFilters } from '../../dashboard/components';
import { EosSourcesFilterContextProvider } from '../../../components/eos/filters/eos-sources-filter';
import { DateRangePresetKey } from '../../dashboard/components/DashboardFilters/useDefaultDateRangePresets';

export const ReportingVentilationDemandRoute = () => {
  const { t } = useTranslation('reporting');
  useRouteDocumentTitle(t('reporting.documentTitle'), ReportingPaths.VentilationVsDemand);
  return (
    <DashboardFiltersProvider dateParamsPrefix="eos">
      <EosSourcesFilterContextProvider>
        <ReportPageContent
          breadcrumb={t('ventilationVsDemandTitle')}
          menu={
            <DashboardFilters
              showOnlySpacesWithEosEnabled
              defaultPresetKey={DateRangePresetKey.TODAY}
              visiblePresets={[
                DateRangePresetKey.TODAY,
                DateRangePresetKey.YESTERDAY,
                DateRangePresetKey.TWODAYSAGO,
                DateRangePresetKey.CUSTOM,
              ]}
              useHierarchicalSpaceSelection={true}
              selectMultipleSpaces={false}
            />
          }
        >
          <AirQualityGraphSection />
        </ReportPageContent>
      </EosSourcesFilterContextProvider>
    </DashboardFiltersProvider>
  );
};
